export default __webpack_public_path__ + "static/principles-of-use-dont-light-e501cbe0681204d7608619b5fb18097aecf487fdbcce8bff910cbbef268291b1.png";